import { CartAddEvent } from '@theme/events';

if (!window.__nbfCardsReady) {
  window.__nbfCardsReady = true;

  const fmt = (cents) =>
    '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  const updateShip = (card, priceCents) => {
    const ship = card.querySelector('.nbf-card__ship');
    if (!ship) return;
    const missing = Number(ship.dataset.threshold) - priceCents;
    ship.innerHTML = missing > 0
      ? `Agrega <strong>${fmt(missing)}</strong> más y tu envío es gratis`
      : '<strong>Envío gratis</strong> con este pack';
  };

  document.addEventListener('click', async (e) => {
    const pill = e.target.closest('.nbf-card__pill');
    if (pill) {
      const card = pill.closest('.nbf-card');
      card.querySelectorAll('.nbf-card__pill').forEach((p) => {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
      card.querySelector('.nbf-card__now').textContent = pill.dataset.price;
      const was = card.querySelector('.nbf-card__was');
      was.textContent = pill.dataset.compare;
      was.hidden = !pill.dataset.compare;
      card.querySelector('.nbf-card__atc').dataset.variantId = pill.dataset.variantId;
      updateShip(card, Number(pill.dataset.priceCents));
      return;
    }

    const btn = e.target.closest('.nbf-card__atc');
    if (!btn || btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Agregando…';
    try {
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((c) => c.dataset.sectionId)
        .filter(Boolean);
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Error');
      btn.textContent = 'Agregado ✓';
      btn.classList.add('is-done');
      document.dispatchEvent(
        new CartAddEvent({}, btn.dataset.variantId, {
          source: 'nbf-cards',
          itemCount: 1,
          productId: btn.closest('.nbf-card').dataset.productId,
          sections: data.sections,
        })
      );
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
      if (!drawer) window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
    } catch (err) {
      btn.textContent = 'Intenta de nuevo';
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-loading', 'is-done');
        btn.textContent = label;
      }, 1800);
    }
  });

  // Flechas de los carruseles
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-nbf-rail-arrow]');
    if (!arrow) return;
    const track = arrow.closest('.nbf-rail').querySelector('.nbf-rail__track');
    const card = track.querySelector('.nbf-card');
    const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    track.scrollBy({ left: arrow.dataset.nbfRailArrow === 'next' ? step : -step, behavior: 'smooth' });
  });
}
